import { useState, useEffect } from "react";
import ApiCall from "../auth/ApiCall";

// interface SportsMetadataResponse {
//   data?: Record<string, unknown>;
//   error?: string;
// }

export function useSportsMetadata() {
  const [sportsMetadata, setSportsMetadata] = useState<Record<string, unknown>>(
    {}
  );
  const [isSportsLoading, setIsSportsLoading] = useState(true);
  const [sportsError, setSportsError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSportsMetadata = async () => {
      try {
        const response = await ApiCall.makeAuthenticatedRequest(
          "/api/sport_metadata/"
        );

        if ("error" in response) {
          setSportsError(response.error as string);
        } else {
          setSportsMetadata(response);
        }
      } catch (err: unknown) {
        setSportsError(
          err instanceof Error ? err.message : "Failed to fetch sports metadata"
        );
      } finally {
        setIsSportsLoading(false);
      }
    };

    fetchSportsMetadata();
  }, []);

  return { sportsMetadata, isSportsLoading, sportsError };
}
